<template>
  <div id="app">
    <a-locale-provider :locale="pl_PL">
      <router-view />
    </a-locale-provider>
  </div>
</template>
<script>
import moment from 'moment'
import pl_PL from 'ant-design-vue/lib/locale-provider/pl_PL'

moment.locale('pl')

export default {
  data() {
    return {
      pl_PL
    }
  },
  created() {
    if (window.localStorage.getItem('token')) {
      this.$store.dispatch('fetchUserInfo')
    }
  }
}
</script>
<style lang="scss">
* {
  box-sizing: border-box;
}

.fluid {
  width: 100% !important;
}

.flex-wrapper {
  display: flex;
  justify-content: space-between;
}

.shrunken-form-item {
  margin-bottom: 10px !important;
}

.ant-btn-icon-only.ant-btn-link {
  color: #333333;
  font-size: 20px;
}

.ant-alert-description {
  white-space: pre-line;
}

.ant-upload {
  width: 100% !important;
}

.ant-btn-link {
  padding: 0 !important;
}

.borderless > .ant-select-selection {
  border: 0 !important;
}

.underline {
  text-decoration: underline !important;
}

.text-center {
  text-align: center;
}

.spinner-wrapper {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-margin-and-padding {
  margin: 0 !important;
  padding: 0 !important;
}

.margin-top-15 {
  margin-top: 15px !important;
}

.margin-left-15 {
  margin-left: 15px !important;
}

.margin-bottom-15 {
  margin-bottom: 15px !important;
}

.margin-right-15 {
  margin-right: 15px;
}

.margin-top-30 {
  margin-top: 30px !important;
}

.ant-tag-yellow {
  background: #fdf485 !important;
  color: #4a4a4a !important;
}

.ant-dropdown-menu {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.ant-form-item-label,
.faked-label {
  padding-bottom: 4px !important;
}

.ant-form-item-label > label,
.faked-label {
  font-size: 12px !important;
  color: rgba(38, 38, 38, 0.5) !important;
}

.ant-collapse-borderless {
  background: none !important;
}

.anticon-student {
  background-image: url('./assets/student.svg');
  background-size: contain;
  height: 1em;
  width: 1em;
}

.pre-wrap {
  white-space: pre-wrap;
}

.ant-btn > .anticon + a {
  margin-left: 8px;
}

.collapse-equal-padding {
  padding: 0 16px;
}
</style>
